import { render, staticRenderFns } from "./ekiosk-kpi-past-3-years-dashboard.vue?vue&type=template&id=1c60a16a&scoped=true&"
import script from "./ekiosk-kpi-past-3-years-dashboard.vue?vue&type=script&lang=js&"
export * from "./ekiosk-kpi-past-3-years-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./ekiosk-kpi-past-3-years-dashboard.vue?vue&type=style&index=0&id=1c60a16a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c60a16a",
  null
  
)

export default component.exports